angular.module('unergie.main')
.directive('landscapeCanvas', ($location, $state, LandscapeElements) =>
    ({
        restrict: 'E',
        replace: true,
        templateUrl: '/directives/landscape-canvas/landscape-canvas.html',
        scope: {},
        link(scope, element, attrs) {
            scope.LE = LandscapeElements
            return scope.$watchCollection('LE.LandscapeElements', (landscapeElements) => (scope.landscapeElements = landscapeElements))
        },
    }),
)
